<div>
  @if (loading) {
    <span class="ag-icon ag-icon-loading" role="presentation" unselectable="on"></span>
  } @else {
    <ng-container>
      @if (sections.length) {
        @for (section of sections; track section) {
          <div class="mt-3">
            <div style="display: flex;gap: 10px;">
              <table class="table">
                <thead>
                <tr>
                  <th [style.background-color]="section.color_code" class="w-30-percent">{{
                      'quote_part.distribution_key' |
                        translate
                    }}
                  </th>
                  <th [style.background-color]="section.color_code">{{ 'quote_part.owner' | translate }}
                  </th>
                  <th [style.background-color]="section.color_code">{{
                      'quote_part.quote_part' | translate
                    }}
                  </th>
                  <th [style.background-color]="section.color_code">{{
                      'quote_part.property_code' |
                        translate
                    }}
                  </th>
                    <th [style.background-color]="section.color_code">{{'Label' | translate}} {{
                            'quote_part.property_code' |
                                translate
                        }}
                    </th>
                </tr>
                </thead>
                <tbody>
                  @for (row of section.sponsors; track row; let i = $index) {
                    <tr class="bg-white">
                      <!-- Display the key only for the first row -->
                      <td (click)="showDetailOrEdit(section.id, $event)" class="text-wrap align-middle w-30-percent" *ngIf="i === 0"
                          [attr.rowspan]="section.sponsors.length">{{
                          section.name
                        }}
                      </td>
                      <td class="w-20-percent">{{ row.name }}</td>
                      <td class="w-10-percent">{{ row.percentage }} %</td>
                      <td class="w-15-percent">{{ row.property_code }}</td>
                      <td>{{ row.property_code_label }}</td>
                    </tr>
                  }
                </tbody>
              </table>
              <div class="header-icons align-items-center">
                <button nbButton ghost class="btn btn-sm btn-outline-danger" (click)="showDetailOrEdit(section.id, $event)" *ngIf="isAllowEditable">
                  <i class="fa-thin fa-pen-to-square"></i>
                </button>
                <button nbButton ghost class="btn btn-sm btn-outline-danger" (click)="onDeleteSection(section)" *ngIf="isAllowEditable">
                  <i class="fa-thin fa-trash-can"></i>
                </button>
              </div>
            </div>
          </div>
        }
      } @else {
        <table class="table skeleton">
          <thead>
          <tr>
            <th [style.background-color]="'#F9F1B9'" class="w-30-percent align-middle">
              {{ 'quote_part.distribution_key' |translate }}
            </th>
            <th [style.background-color]="'#F9F1B9'" class="align-middle">
              {{ 'quote_part.owner' | translate }}
            </th>
            <th [style.background-color]="'#F9F1B9'" class="align-middle">
              {{ 'quote_part.quote_part' |translate }}
            </th>
            <th [style.background-color]="'#F9F1B9'" class="align-middle">
              {{ 'quote_part.property_code' |translate }}
            </th>
            <th [style.background-color]="'#F9F1B9'" class="align-middle">
              {{ 'Label' | translate }} {{ 'quote_part.property_code' | translate }}
            </th>
            <th [style.background-color]="'#F9F1B9'">
            </th>
            <th [style.background-color]="'#F9F1B9'">
            </th>
          </tr>
          </thead>
          <tbody>
            <tr class="bg-white">
              <td class="w-15-percent"></td>
              <td class="w-15-percent"></td>
              <td class="w-15-percent"></td>
              <td class="w-15-percent"></td>
              <td class="w-15-percent"></td>
              <td class="align-middle">
                <span>
                  <i class="fa-light fa-pen-to-square"></i>
                </span>
              </td>
              <td class="align-middle">
                <span>
                  <i class="fa-light fa-trash-can"></i>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      }
    </ng-container>
  }
  @if (isAllowEditable) {
    <a class="add-new-btn btn pe-auto" href="#" (click)="openAddNewPopup($event)"> {{ 'quote_part.add_new_btn' | translate }}</a>
  }
</div>
